var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-row",class:_vm.rowClasses,style:(_vm.rowStyle)},[_vm._t("drag-handle"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }